var map = {
	"./1-1280w.jpg": 7714,
	"./1-1920w.jpg": 4265,
	"./1-300w.jpg": 1450,
	"./1-768w.jpg": 8576,
	"./2-1280w.jpg": 2433,
	"./2-1920w.jpg": 2710,
	"./2-300w.jpg": 1371,
	"./2-768w.jpg": 2201,
	"./3-1280w.jpg": 3972,
	"./3-1920w.jpg": 7987,
	"./3-300w.jpg": 704,
	"./3-768w.jpg": 4306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4630;